import { AlertCircle, CheckCircle } from 'lucide-react';

interface AuthAlertProps {
  type: 'error' | 'success';
  message: string;
}

export const AuthAlert = ({ type, message }: AuthAlertProps) => {
  const isError = type === 'error';

  return (
    <div
      className={`flex items-start gap-2.5 rounded-lg px-3.5 py-3 mb-3 ${
        isError ? 'bg-[#FF8A00]/10 border border-[#FF8A00]/30' : 'bg-green01/10 border border-green01/30'
      }`}
    >
      {isError ? (
        <AlertCircle size={16} className="text-[#FF8A00] shrink-0 mt-0.5" />
      ) : (
        <CheckCircle size={16} className="text-green01 shrink-0 mt-0.5" />
      )}
      <p className="text-white text-xs text-left leading-relaxed">{message}</p>
    </div>
  );
};
